import { Link } from 'react-router'

import { Card } from '../ui'
import type { ComparisonJournal } from '../../lib/api'
import { CAFFEINE_LAST_LABELS, INTENSITY_LABELS, QUADRANT_STATES, STATE_OPTIONS, WHEN_AGO_LABELS } from '../../lib/selfReport'

const ABSENT = 'not answered'

/** Board's four groups, from captured structured answers. Complete journals have their own Open link. */
function Journal({ report, time, id }: { report: ComparisonJournal | null; time: string; id: string }) {
  const state = report?.state ?? (report?.state_quadrant == null ? null : QUADRANT_STATES[report.state_quadrant])
  const felt = state == null ? ABSENT : STATE_OPTIONS.find((option) => option.value === state)?.label ?? state
  const coffee = report?.caffeine_last == null ? ABSENT : CAFFEINE_LAST_LABELS[report.caffeine_last]
  const exercise = report?.exercised == null ? ABSENT : report.exercised ? 'Yes' : 'No'
  // Schema 1 asked about the day; only schema 2 asked about this recording.
  // An unknown schema supplies no evidence for either time anchor.
  const stressAnchor = report?.schema_version === 2 ? 'right now' : report?.schema_version === 1 ? 'today' : null
  const dayAnchor = report?.schema_version === 2 ? 'today, before this recording' : report?.schema_version === 1 ? 'today' : null
  return <div className="comparison__journal-column">
    <div className="comparison__journal-head">
      <h2 className="comparison__label">What you reported · {time}</h2>
      <Link className="comparison__journal-open" to={`/history/${encodeURIComponent(id)}`}>Open<span className="visually-hidden"> journal for {time}</span></Link>
    </div>
    {report?.schema_version === 1 && <span className="comparison__muted">Schema 1</span>}
    <dl className="comparison__kv">
      <dt>How you felt{report?.schema_version === 2 && <small>right now</small>}</dt><dd>{felt}</dd>
      <dt>Stress{stressAnchor && <small>{stressAnchor}</small>}</dt><dd>{report?.stress_1_10 == null ? ABSENT : `${report.stress_1_10} of 10`}</dd>
      <dt>Coffee{dayAnchor && <small>{dayAnchor}</small>}</dt><dd>{coffee}
        {report?.caffeine_cups != null && <span className="comparison__journal-detail">{report.caffeine_cups} cups</span>}
      </dd>
      <dt>Exercise{dayAnchor && <small>{dayAnchor}</small>}</dt><dd>{exercise}
        {report?.exercised === true && <span className="comparison__journal-detail">Finished: {report.exercise_finished == null ? ABSENT : WHEN_AGO_LABELS[report.exercise_finished]}</span>}
        {report?.exercise_minutes != null && <span className="comparison__journal-detail">{report.exercise_minutes} min</span>}
        {report?.exercise_intensity != null && <span className="comparison__journal-detail">{INTENSITY_LABELS[report.exercise_intensity]}</span>}
      </dd>
    </dl>
  </div>
}

export function ComparisonJournalColumns({ before, after, beforeTime, afterTime, beforeId, afterId }: {
  before: ComparisonJournal | null; after: ComparisonJournal | null; beforeTime: string; afterTime: string
  beforeId: string; afterId: string
}) {
  return <Card as="section" flat className="comparison__journals" aria-label="What you reported">
    <Journal report={before} time={beforeTime} id={beforeId} /><Journal report={after} time={afterTime} id={afterId} />
  </Card>
}
